import { Box, Container, Flex, Text, Heading, Grid } from '@radix-ui/themes';
import { Image } from '@trashlab/sitesapp/src/organizations/best-deal/components/shared/image';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/best-deal/contexts/use-tenant-context';
import { Button } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/shared/button';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/best-deal/lib/utils/get-variant-value';
import { asAddress } from '@trashlab/api/src/library/server/utils/json-compatibility';

export const WhoWeAre = () => {
  const { website } = useTenantContext();
  const orgAddress = asAddress(website?.organization?.address as any);
  const city = orgAddress?.city ?? 'San Francisco';
  const state = orgAddress?.state ?? 'CA';

  const aboutTitle = useVariantValue(
    'ABOUT_TITLE',
    'Voted #1 best dumpster rental company',
  );
  const aboutContent = useVariantValue(
    'ABOUT_CONTENT',
    `${website?.organization?.name || 'Our company'} is a reputable,
    locally owned and operated dumpster rental service serving ${city}, ${state}, and the surrounding communities.
    ${website?.organization?.name || 'Our company'} is renowned for
    our commitment to cater to a wide array of needs while providing
    reliable and affordable waste management solutions, from residential
    cleanups to commercial projects, there isn't a job we can't handle.
    We take pride in our signature same-day rental service, delivering
    your dumpster whenever is most convenient to you, ensuring a
    hassle-free waste removal process.
    Our wide selection of dumpsters guarantees you will rent the right
    dumpster to accommodate your home or businesses waste removal needs.
    At ${website?.organization?.name || 'our company'}, we value our
    community, prioritizing punctuality, professionalism, and
    unparalleled service.`,
  );
  const whoWeAreTitle = useVariantValue('WHO_WE_ARE_TITLE', 'Who we are');
  const faqButtonText = useVariantValue(
    'FAQ_BUTTON_TEXT',
    'View dumpster rental FAQ',
  );
  const whoWeAreImage = useVariantValue(
    'ABOUT_US_IMAGE',
    '/default/who-we-are.svg',
  );

  return (
    <Container size="4" p="8">
      <Grid
        columns={{ initial: '1', xs: '2' }}
        width="auto"
        justify="center"
        align="center"
        className="items-center"
      >
        <Flex direction="column" gap="2" className="h-full flex justify-center">
          <Text
            size="2"
            weight="bold"
            className="text-neutral-400"
            data-variable="ABOUT_TITLE"
          >
            {aboutTitle}
          </Text>

          <Heading as="h2" size="8" data-variable="WHO_WE_ARE_TITLE">
            {whoWeAreTitle}
          </Heading>

          <Text
            size="3"
            className="max-w-[calc(100%-30px)]"
            data-variable="ABOUT_CONTENT"
          >
            {aboutContent}
          </Text>

          <Box className="flex items-center col-span-1 mt-2 mb-6 md:mb-2">
            <Button
              href="/dumpster-faq"
              withArrow
              title="View frequently asked questions about dumpster rentals"
              aria-label="Learn more about our dumpster rental services by reading our FAQ"
              data-variable="FAQ_BUTTON_TEXT"
            >
              {faqButtonText}
            </Button>
          </Box>
        </Flex>

        <Box
          className="flex justify-center items-center"
          data-variable="ABOUT_US_IMAGE"
        >
          <Image
            src={whoWeAreImage}
            alt="Dumpster service"
            className="rounded-lg"
          />
        </Box>
      </Grid>
    </Container>
  );
};

export default WhoWeAre;
